export const TRANSCRIPTION_LOCALE = {
  Afrikaans: 'af-ZA',
  Albanian: 'sq-AL',
  Amharic: 'am-ET',
  Arabic: 'ar',
  Armenian: 'hy-AM',
  Azerbaijani: 'az-AZ',
  Basque: 'eu-ES',
  Bengali: 'bn',
  Bosnian: 'bs-BA',
  Bulgarian: 'bg-BG',
  Catalan: 'ca-ES',
  'Chinese (simplified)': 'zh-CN',
  'Chinese (traditional)': 'zh-TW',
  Croatian: 'hr-HR',
  Czech: 'cs-CZ',
  Danish: 'da-DK',
  Dutch: 'nl-NL',
  'English (USA)': 'en-US',
  'English (British)': 'en-GB',
  Estonian: 'et-EE',
  Finnish: 'fi-FI',
  French: 'fr-FR',
  Galician: 'gl-ES',
  German: 'de-DE',
  Greek: 'el-GR',
  Gujarati: 'gu-IN',
  Hindi: 'hi-IN',
  Hungarian: 'hu-HU',
  Icelandic: 'is-IS',
  Indonesian: 'id-ID',
  Italian: 'it-IT',
  Japanese: 'ja-JP',
  Javanese: 'jv-ID',
  Kannada: 'kn-IN',
  Kazakh: 'kk-KZ',
  Khmer: 'km-KH',
  Korean: 'ko-KR',
  Lao: 'lo-LA',
  Latvian: 'lv-LV',
  Lithuanian: 'lt-LT',
  Macedonian: 'mk-MK',
  Malay: 'ms-MY',
  Malayalam: 'ml-IN',
  Marathi: 'mr-IN',
  Mongolian: 'mn-MN',
  Nepali: 'ne-NP',
  Norwegian: 'no-NO',
  Persian: 'fa-IR',
  Polish: 'pl-PL',
  Romanian: 'ro-RO',
  'Portuguese (Portugal)': 'pt-PT',
  'Portuguese (Brazil)': 'pt-BR',
  Russian: 'ru-RU',
  Serbian: 'sr-RS',
  Sinhala: 'si-LK',
  Slovak: 'sk-SK',
  Slovenian: 'sl-SI',
  Spanish: 'es-ES',
  Sundanese: 'su-ID',
  Swahili: 'sw',
  Swedish: 'sv-SE',
  Tamil: 'ta',
  Telugu: 'te-IN',
  Thai: 'th-TH',
  Turkish: 'tr-TR',
  Ukrainian: 'uk-UA',
  Urdu: 'ur',
  Uzbek: 'uz-UZ',
  Vietnamese: 'vi-VN',
};

export default TRANSCRIPTION_LOCALE;
